import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }

import LineCharts from './components/simple/line.vue'
  import BarCharts from './components/simple/bar.vue'
  import PieCharts from './components/simple/pie.vue'
  import ScatterCharts from './components/simple/scatter.vue'
  import GaugeCharts from './components/simple/gauge.vue'
  import FunnelCharts from './components/simple/funnel.vue'
  import CandlestickCharts from './components/simple/candlestick.vue'
  import RadarCharts from './components/simple/radar.vue'
  import GraphCharts from './components/simple/graph.vue'
  import PictorialBarCharts from './components/simple/pictorialBar.vue'
  import PictorialBar from "@/views/charts/components/simple/pictorialBar.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'simple',
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, {
      class: "row-bg",
      gutter: 10
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 12,
          lg: 8
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "box-card" }, {
              header: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("span", null, "折线图")
                ], -1)
              ])),
              default: _withCtx(() => [
                _createVNode(LineCharts, {
                  height: "200px",
                  width: "100%"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 12,
          lg: 8
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "box-card" }, {
              header: _withCtx(() => _cache[1] || (_cache[1] = [
                _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("span", null, "柱状图")
                ], -1)
              ])),
              default: _withCtx(() => [
                _createVNode(BarCharts, {
                  height: "200px",
                  width: "100%",
                  id: "bar"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 12,
          lg: 8
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "box-card" }, {
              header: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("span", null, "饼图")
                ], -1)
              ])),
              default: _withCtx(() => [
                _createVNode(PieCharts, {
                  height: "200px",
                  width: "100%",
                  id: "pie"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 12,
          lg: 8
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "box-card" }, {
              header: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("span", null, "散点图")
                ], -1)
              ])),
              default: _withCtx(() => [
                _createVNode(ScatterCharts, {
                  height: "200px",
                  width: "100%",
                  id: "scatter"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 12,
          lg: 8
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "box-card" }, {
              header: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("span", null, "仪表盘")
                ], -1)
              ])),
              default: _withCtx(() => [
                _createVNode(GaugeCharts, {
                  height: "200px",
                  width: "100%",
                  id: "gauge"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 12,
          lg: 8
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "box-card" }, {
              header: _withCtx(() => _cache[5] || (_cache[5] = [
                _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("span", null, "漏斗图")
                ], -1)
              ])),
              default: _withCtx(() => [
                _createVNode(FunnelCharts, {
                  height: "200px",
                  width: "100%",
                  id: "funnel"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 12,
          lg: 8
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "box-card" }, {
              header: _withCtx(() => _cache[6] || (_cache[6] = [
                _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("span", null, "K 线图")
                ], -1)
              ])),
              default: _withCtx(() => [
                _createVNode(CandlestickCharts, {
                  height: "200px",
                  width: "100%",
                  id: "candlestick"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 12,
          lg: 8
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "box-card" }, {
              header: _withCtx(() => _cache[7] || (_cache[7] = [
                _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("span", null, "雷达图")
                ], -1)
              ])),
              default: _withCtx(() => [
                _createVNode(GraphCharts, {
                  height: "200px",
                  width: "100%",
                  id: "graph"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          xs: 24,
          sm: 12,
          lg: 8
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_card, { class: "box-card" }, {
              header: _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("div", { class: "card-header" }, [
                  _createElementVNode("span", null, "虚线柱状图效果")
                ], -1)
              ])),
              default: _withCtx(() => [
                _createVNode(PictorialBar, {
                  height: "200px",
                  width: "100%",
                  id: "pictorial"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})